import { useRefinementList } from 'react-instantsearch';

// InstantSearch ignores refinementList keys until a widget registers the attribute.
export default function RegisterFamilyLevelRefinements(): null {
  useRefinementList({ attribute: 'familyLvl1' });
  useRefinementList({ attribute: 'familyLvl2' });
  useRefinementList({ attribute: 'familyLvl3' });
  useRefinementList({ attribute: 'familyLvl4' });

  return null;
}
